<div class="tag" [style]="{
  'font': tag?.font }">
  <p [style]="{
    'color': tag?.color
  }">{{tag?.message}}</p>
</div>